import config from 'config';
import { genericLayoutFactory } from 'utils/layoutUtils';
import {topMPUProps, bannerAd} from "../Common/components/GptProperties";

const columnistsLayout = {
  bannerAd: bannerAd,
  leaderboardAd: {
    view: 'home-page'
  },
  components: [
    {
      component: 'SectionPlainTitle',
      props: {
        level: 1,
        className: 'page-main-section-title',
        children: 'Columnists'
      },
      desktopColumn: 'left',
      desktopOrder: 1,
      handheldOrder: 1
    },
    {
      component: 'MoreNews',
      desktopColumn: 'left',
      desktopOrder: 2,
      handheldOrder: 2
    },
    {
      component: "MostReadAll",
      desktopColumn: "right",
      desktopOrder: 1,
      handheldOrder: 3
    },
    {
      component: 'GooglePublisherTag',
      props: topMPUProps,
      desktopColumn: 'right',
      desktopOrder: 1,
      handheldOrder: false
    },
    {
      component: 'AdvertWrapper',
      props: {
        ocSlot: ["homepage", "mpu"],
        additionalProperties: {
          view: 'home-page'
        }
      },
      desktopColumn: 'right',
      desktopOrder: 2,
      handheldOrder: false
    },
    {
      component: 'RacingTips',
      props: {
        plainTitle: true
      },
      desktopColumn: 'right',
      desktopOrder: 4,
      handheldOrder: false
    },
    {
      component: 'HorseRacingNextRaceOff',
      props: {
        plainTitle: true
      },
      desktopColumn: 'right',
      desktopOrder: 5,
      handheldOrder: false
    },
    {
      component: 'FootballTips',
      props: {
        plainTitle: true
      },
      desktopColumn: 'right',
      desktopOrder: 7,
      handheldOrder: false
    }
  ]
};

export default {
  '/columnists': columnistsLayout,
  '/news/:basketName/:basketId': (layout, context) => {
    const {
      params: {
        basketId
      } = {},
      state: {
        common: {
          morenews: {
            [basketId]: {
              path = ""
            } = {}
          } = {}
        } = {}
      } = {}
    } = context;

    let [,section] = path.split("/");

    section = ({
      homepage: "home",
      columnists: "home"
    }[section]) || section;

    const customBasketLayout = {
      section,
      ...genericLayoutFactory("custom-basket", section).withAdverts({
        component: "CustomBasketNews",
        desktopOrder: 1,
        handheldOrder: 1,
        desktopColumn: "left"
      })
    };
 
    return customBasketLayout;
  }
};





// WEBPACK FOOTER //
// ./modules/News/layouts.js